import { render, staticRenderFns } from "./print-table-two.vue?vue&type=template&id=415afca9&scoped=true"
import script from "./print-table-two.vue?vue&type=script&lang=js"
export * from "./print-table-two.vue?vue&type=script&lang=js"
import style0 from "./print-table-two.vue?vue&type=style&index=0&id=415afca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415afca9",
  null
  
)

export default component.exports